import { memo } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function TicketsLoadingSpinner() {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    "data-test-id": "tickets-loading-spinner",
    className: "m-bottom-2",
    layout: "centered"
  });
}
export default /*#__PURE__*/memo(TicketsLoadingSpinner);